import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import { type ThemeProviderProps } from "next-themes/dist/types";
import { dashboardThemeCookie } from "@/lib/dashboardThemeCookie";
function DashboardThemeCookie() {
  const $ = _c(3);
  const {
    resolvedTheme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] !== resolvedTheme) {
    t0 = () => {
      if (resolvedTheme !== "light" && resolvedTheme !== "dark") {
        return;
      }
      if (window.origin === "null") {
        return;
      }
      document.cookie = dashboardThemeCookie(resolvedTheme);
    };
    t1 = [resolvedTheme];
    $[0] = resolvedTheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  return null;
}
export function ThemeProvider(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DashboardThemeCookie />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <NextThemesProvider {...props}>{t1}{children}</NextThemesProvider>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}